export default function R_Bars() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Bars Component</h1>
      <p>This is the R_Bars tutorial section.</p>
    </div>
  );
}
